export default [
  {
    "role": "Dealer Admin",
    "value": "dealeradmin",
  },
  {
    "role": "Dealer Tech",
    "value": "dealertech",
  },
  {
    "role": "Client",
    "value": "client",
  },
]